import React from "react";
import Background1 from "../../assets/images/breadcum/01.jpg";
import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios";

export default function ClubsandHousecouncil() {
  const [dataDesc, setData] = useState("");
  const [title, setTitle] = useState("");
  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BASE_API_URL}/api/cms/slug/clubs-and-house-council`
        );

        setData(res.data.Description);
        setTitle(res.data.Title);
      } catch (error) {
        console.error("Error fetching CMS content:", error);
      }
    };

    fetchData();
  }, []);


  return (
    <>
      {/* <!--inner-header --> */}
      <section
        className="inner-banner bg-overlay-black-70 bg-holder"
        style={{ backgroundImage: `url(${Background1})` }}
      >
        <div className="container">
          <div className="row d-flex justify-content-center">
            <div className="col-md-12">
              <div className="text-center">
                <h1 className="text-white">Clubs and House council</h1>
              </div>
              <div className="d-flex justify-content-center ">
                <ol className="breadcrumb mb-0 p-0">
                  <li className="breadcrumb-item">
                    <Link to="/">Home</Link>
                  </li>
                  <li className="breadcrumb-item">
                    <a href="#">School Life</a>
                  </li>
                  <li className="breadcrumb-item active">
                    <span>Clubs and House council</span>
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* <!--inner-header --> */}
      {/* <!--about --> */}
      <section className="clubs-societies-section">
        <div className="container">
          <div className="row align-items-center justify-content-center">
            <div className="col-xl-10 col-lg-10">
              <div className="shadow border-radius box-border-bottom p-4">
                <div className="row">
                  <div className="col-xl-12 col-lg-12">
                    <div className="">
                    {React.createElement('div',{ dangerouslySetInnerHTML: { __html: dataDesc } })}

                    </div>
                    <div className="mt-5 mb-4">
                      {/* <p className="text-justify">
                        Every child is unique. With the idea that every individual has some inborn talent, we vow to recognize and develop this inherent style. With an aim to develop the overall skills of the students, the school has established Hobby Clubs with a unique vision. These clubs are interactive and intellectually, physically and emotionally stimulating. Experts from their respective fields moderate the activities and encourage children to participate and develop themselves.
                      </p>
                      <ul>
                        <li>Financial Literacy Club</li>
                        <li>Science Club</li>
                        <li>French Club</li>
                        <li>Fine Arts Club</li>
                        <li>SUPW Club</li>
                        <li>Robotics Club</li>
                        <li>Dramatics Club</li>
                        <li>Fashion Designing Club</li>
                        <li>Self-Defence Club</li>
                        <li>Personality Development Club</li>
                        <li>Gardening Club</li>
                        <li>Enterpreneurship Club</li>
                      </ul> */}
                    </div>
                  </div>{" "}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* <!--about --> */}
    </>
  );
}
